// extracted by mini-css-extract-plugin
export default {"main":"Items_main__PxT9N","nothingImg":"Items_nothingImg__Q8MTu"};